import { render, staticRenderFns } from "./realResult.vue?vue&type=template&id=23a2e5c0&scoped=true&"
import script from "./realResult.vue?vue&type=script&lang=js&"
export * from "./realResult.vue?vue&type=script&lang=js&"
import style0 from "./realResult.vue?vue&type=style&index=0&id=23a2e5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a2e5c0",
  null
  
)

export default component.exports